module.exports = __webpack_public_path__ + "static/media/Why-four.89d0cd05.svg";